import React from "react";

/**
 * Primitiva presentacional de carga (esqueleto). Sin lógica de negocio.
 * Los tokens visuales (color, animación, radio) viven en styles/components/feedback.css.
 * width/height/radius son la API del componente (estilo dinámico legítimo, no valores de marca).
 */
const Skeleton = ({
  width = "100%",
  height = 16,
  radius,
  circle = false,
  className = "",
  style,
  ...rest
}) => {
  const borderRadius = circle ? "999px" : radius;
  return (
    <span
      className={`skeleton ${className}`.trim()}
      aria-hidden="true"
      style={{ width, height, borderRadius, ...style }}
      {...rest}
    />
  );
};

export default Skeleton;
